module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-layout', {
    staticClass: "px-2 pt-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.type,
      "readonly": ""
    },
    model: {
      value: (_vm.report.type),
      callback: function($$v) {
        _vm.$set(_vm.report, "type", $$v)
      },
      expression: "report.type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.companyName,
      "readonly": ""
    },
    model: {
      value: (_vm.report.companyName),
      callback: function($$v) {
        _vm.$set(_vm.report, "companyName", $$v)
      },
      expression: "report.companyName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.month,
      "readonly": ""
    },
    model: {
      value: (_vm.report.month),
      callback: function($$v) {
        _vm.$set(_vm.report, "month", $$v)
      },
      expression: "report.month"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.year,
      "readonly": ""
    },
    model: {
      value: (_vm.report.year),
      callback: function($$v) {
        _vm.$set(_vm.report, "year", $$v)
      },
      expression: "report.year"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.report.createdOn),
      callback: function($$v) {
        _vm.$set(_vm.report, "createdOn", $$v)
      },
      expression: "report.createdOn"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.report.modifiedOn),
      callback: function($$v) {
        _vm.$set(_vm.report, "modifiedOn", $$v)
      },
      expression: "report.modifiedOn"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-4": "",
      "py-4": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('h3', {
    staticClass: "mx-4"
  }, [_vm._v(_vm._s(_vm.$lang.header.paymentSummary))]), _vm._v(" "), (_vm.paymentSummary) ? _c('v-data-table', {
    staticClass: "my-table-paymentSummary text-xs-left",
    attrs: {
      "items": _vm.paymentSummary,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_c('th', {
          staticClass: "text-xs-left ml-3"
        }, [_vm._v(_vm._s(_vm.$lang.header.paymentType))]), _vm._v(" "), _c('th', {
          staticClass: "text-xs-left ml-3"
        }, [_vm._v(_vm._s(_vm.$lang.header.amount))])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.$lang.labels[props.item.paymentType]))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.amount))])]
      }
    }], null, false, 1371613615)
  }) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "mx-4 pt-4"
  }, [_vm._v(_vm._s(_vm.$lang.header.webShops))]), _vm._v(" "), _c('v-data-table', {
    staticClass: "my-table",
    attrs: {
      "items": _vm.report.webShopResources,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_c('th', {
          staticClass: "bottomHeader column text-xs-left"
        }, [_vm._v(_vm._s(_vm.$lang.header.webShopResourceId))]), _vm._v(" "), _c('th', {
          staticClass: "bottomHeader column text-xs-center"
        }, [_vm._v(_vm._s(_vm.$lang.header.paymentSummary))]), _vm._v(" "), _c('th', {
          staticClass: "customHeader"
        }, [_c('td', {
          staticClass: "topHeader"
        }, [_vm._v(_vm._s(_vm.$lang.header.webshop))]), _vm._v(" "), _c('td', {
          staticClass: "bottomHeader column text-xs-center",
          attrs: {
            "role": "columnheader",
            "scope": "col"
          }
        }, [_vm._v(_vm._s(_vm.$lang.license.orders))])]), _vm._v(" "), _c('th', {
          staticClass: "bottomHeader column",
          attrs: {
            "role": "columnheader",
            "scope": "col"
          }
        }, [_vm._v(_vm._s(_vm.$lang.license.totalAmount))]), _vm._v(" "), _c('th', {
          staticClass: "customHeader"
        }, [_c('td', {
          staticClass: "topHeader text-xs-center"
        }, [_vm._v(_vm._s(_vm.$lang.header.orderingApp))]), _vm._v(" "), _c('td', {
          staticClass: "bottomHeader column text-xs-center",
          attrs: {
            "role": "columnheader",
            "scope": "col"
          }
        }, [_vm._v(_vm._s(_vm.$lang.license.orders))])]), _vm._v(" "), _c('th', {
          staticClass: "bottomHeader column text-xs-center",
          attrs: {
            "role": "columnheader",
            "scope": "col"
          }
        }, [_vm._v(_vm._s(_vm.$lang.license.totalAmount))])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.webShopResourceId))]), _vm._v(" "), (props.item.paymentSummary) ? _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._l((props.item.paymentSummary), function(type) {
          return [_c('span', [_vm._v(_vm._s(_vm.$lang.labels[type.paymentType]) + ": " + _vm._s(type.amount))]), _c('br')]
        })], 2) : _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("-")]), _vm._v(" "), (props.item.ordersData) ? _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.ordersData.webshop ? props.item.ordersData.webshop.noOfOrders : '-'))]) : _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("-")]), _vm._v(" "), (props.item.ordersData) ? _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.ordersData.webshop ? props.item.ordersData.webshop.ordersSum : '-'))]) : _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("-")]), _vm._v(" "), (props.item.ordersData) ? _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.ordersData['ordering app'] ? props.item.ordersData['ordering app'].noOfOrders : '-'))]) : _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("-")]), _vm._v(" "), (props.item.ordersData) ? _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.item.ordersData['ordering app'] ? props.item.ordersData['ordering app'].ordersSum : '-'))]) : _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n      " + _vm._s(_vm.$lang.actions.close) + "\n    ")], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8707a304","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/WebshopReportsModal.vue
// module id = 592
// module chunks = 11